import { jsx as _jsx } from "react/jsx-runtime";
import SearchField from "@components/input/SearchField";
import useTranslations from "@hooks/useTranslations";
const MobileSearchPage = () => {
    const { t } = useTranslations();
    return (_jsx("div", { className: "px-4 py-4", children: _jsx(SearchField, { label: t("BDO.LiveSite.Header.Search") }) }));
};
export default MobileSearchPage;
